import DetailsBookingProvider from 'components/DetailsBookingProvider';
import LiveChat from 'components/LiveChat/LiveChat';
import withAuthentication from 'components/withAuthentication';
import useSplitTreatment from 'hooks/useSplitTreatment';
import LoadingPage from 'pages/LoadingPage';
import NotFoundPage from 'pages/NotFoundPage';
import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { SplitIO } from 'types';
import LoginPage from '../LoginPage';

const BookingAccessRoute = ({
  component: Component,
  retrieveBookingAuthMethod,
  hasFetchedBookingAuthMethod,
  isAuthenticating,
  isAuthenticated,
  isSSO,
  authMethod,
  hasInitializedSSO,
  ...routeProps
}) => {
  const { isReady, split } = useSplitTreatment(SplitIO.Split.SELF_SERVICE_OAUTH, SplitIO.Treatment.ON);
  const { bookingId } = routeProps.computedMatch.params;

  useEffect(() => {
    if (!isReady) {
      return;
    }
    // TODO: I don't know why we need retrieveBookingAuthMethod here, what was the original implementation?
    retrieveBookingAuthMethod({ bookingId, split });
  }, [bookingId, retrieveBookingAuthMethod, split, isReady]);

  return (
    <Route
      {...routeProps}
      render={(props) => {
        if (!isReady || !hasFetchedBookingAuthMethod || !authMethod) {
          return <LoadingPage />;
        }

        if (authMethod === 'unknown') {
          return <NotFoundPage />;
        }

        if (!isAuthenticated) {
          return <LoginPage data-testid="login-form" isSSO={isSSO} hasInitializedSSO={hasInitializedSSO} bookingId={bookingId} />;
        }

        return (
          <DetailsBookingProvider>
            <Component {...props} isSSO={isSSO} />
            <LiveChat />
          </DetailsBookingProvider>
        );
      }}
    />
  );
};

export default withAuthentication(BookingAccessRoute);
